export default  {
  bindings: {
    currentProperty: '<',
    properties: '<'
  },
  controller: 'appController',
  template: require('../views/app.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/app.component.js